import { Model } from 'backbone';

class BehaviorInstanceModel extends Model {

    initialize() {
    }


    defaults() {
        const def = {};
        def.id = '';
        def.objectId = '';
        def.behaviorKey = '';
        def.text = '';
        def.open = false;
        def.factoryKey = 'behavior_instance';
        def.owner = '';
        def.status = 'OK';
        def.showProcessing = true;
        def.width = 600;
        def.height = 600;

        return def;
    }


}

export default BehaviorInstanceModel;